import * as styles from "../MeterReadingsPage.styles";

const CONFIDENCE_BADGE = {
  high: styles.badgeHigh,
  medium: styles.badgeMedium,
  low: styles.badgeLow,
} as const;

const CONFIDENCE_KEYS = {
  high: "meterReadings:review.confidenceHigh",
  medium: "meterReadings:review.confidenceMedium",
  low: "meterReadings:review.confidenceLow",
} as const;

const STATUS_KEYS = {
  EXTRACTED: "meterReadings:history.statusExtracted",
  EMAILED: "meterReadings:history.statusEmailed",
  SUBMITTED: "meterReadings:history.statusSubmitted",
  FAILED: "meterReadings:history.statusFailed",
} as const;

const STATUS_BADGE = {
  EXTRACTED: styles.badgeHigh,
  EMAILED: styles.badgeHigh,
  SUBMITTED: styles.badgeHigh,
  FAILED: styles.badgeLow,
} as const;

export { CONFIDENCE_BADGE, CONFIDENCE_KEYS, STATUS_KEYS, STATUS_BADGE };
